import { ipCategories } from "@/mocks/doujinshi";

export default function IpSection() {
  return (
    <section id="ips" className="w-full bg-background-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-accent-400">
              <i className="ri-command-line"></i>
              COLLECTION
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              热门IP分类
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-500 md:text-base">
              从经典长篇到人气新番，我们按IP整理了海量同人合集。点击进入对应分类，找到属于你的本命宇宙。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <a
              href="#latest"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/40 px-4 py-2 text-sm font-medium text-foreground-500 transition-colors hover:border-accent-400/50 hover:text-accent-300"
            >
              <i className="ri-time-line"></i>
              查看更新
            </a>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {ipCategories.map((ip) => (
            <a
              key={ip.id}
              href="#featured"
              className="group relative flex min-h-[360px] flex-col justify-end overflow-hidden rounded-lg ring-1 ring-background-200/50 transition-all duration-300 hover:-translate-y-1 hover:ring-accent-400/60"
            >
              <img
                src={ip.cover}
                alt={`${ip.name}同人漫画分类封面`}
                title={`${ip.name} 同人合集`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent"></div>
              <div className="relative z-10 p-5">
                <span className="text-[11px] font-bold uppercase tracking-widest text-accent-400">
                  {ip.english}
                </span>
                <h3 className="mt-2 font-heading text-xl font-black text-foreground-950">
                  {ip.name}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-400">
                  {ip.tagline} · {ip.description}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="rounded-full bg-primary-500/20 px-2.5 py-1 text-xs font-bold text-primary-300">
                    {ip.count} 部作品
                  </span>
                  <span className="flex items-center gap-1 text-xs font-medium text-accent-300 opacity-0 transition-opacity group-hover:opacity-100">
                    进入分类 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}